var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.498 10.887L22.315 2h-1.852l-6.788 7.717L8.253 2H2l8.198 11.669L2 22.989h1.853l7.168-8.149 5.726 8.149H23l-8.502-12.102zm-2.537 2.885l-.831-1.162-6.61-9.246h2.846l5.334 7.462.831 1.162 6.933 9.699h-2.846l-5.657-7.914v-.001z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgX;